export const CHANGE_PAGE = 'CHANGE_PAGE'
